'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UNDERLINE_CLASSES = exports.UNDERLINE_CLASSES = {
  'false': 'uiLinkWithoutUnderline',
  'true': 'uiLinkWithUnderline private-link--underlined'
};

var USE_CLASSES = exports.USE_CLASSES = {
  'blue': '',
  'dark': 'uiLinkDark',
  'danger': 'private-link--danger',
  'light': 'uiLinkLight',
  'on-dark': 'uiLinkLight private-link--on-dark',
  'mention': 'private-link--mention',
  'unstyled': 'private-link--unstyled'
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/link/LinkConstants.js
// module id = 255
// module chunks = 0 1